<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    width="300px"
  >
    <el-select
      class="select_btn_style"
      v-model="graduationType"
      placeholder="请选择结业状态"
      v-if="dialogInfo.type === 1"
    >
      <el-option
        v-for="(item, i) in graduationStatusData"
        :key="i"
        :label="item.paramValue"
        :value="item.paramKey"
      ></el-option>
    </el-select>
    <el-input-number
      v-model="days"
      :precision="2"
      :min="0"
      v-if="dialogInfo.type === 2"
    ></el-input-number>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateTrainDays, updateGraduation } from "@/api/enrollOffline";
export default {
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          type: 1,
          title: "修改结业状态",
          days: 0,
          graduationStatus: null,
        };
      },
    },
    graduationStatusData: {
      tyep: Array,
      default: [],
    },
  },
  data() {
    return {
      graduationType: null,
      days: 0,
    };
  },
  created() {
    this.days = this.dialogInfo.days || 0;
    this.graduationType = this.dialogInfo.graduationStatus + "" || null;
  },
  methods: {
    confirm() {
      let type = this.dialogInfo.type;
      if (type === 1) {
        updateGraduation({
          graduationType: this.graduationType,
          uuid: this.dialogInfo.uuid,
        }).then(({ code }) => {
          if (code !== 0) return;
          this.graduationType = null;
          this.$emit("close", true);
        });
      }
      if (type === 2) {
        updateTrainDays({ days: this.days, uuid: this.dialogInfo.uuid }).then(
          ({ code }) => {
            if (code !== 0) return;
            this.days = 0;
            this.$emit("close", true);
          }
        );
      }
    },
    close(flag = false) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style>
</style>